import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserForm from "./userForm";
import { deleteUser } from "../api/api";

export default function UserList() {
  const [user, setuser] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [activeTab, setActiveTab] = useState("users");
  const [series, setSeries] = useState([]);
  const [enregistreurs, setEnregistreurs] = useState([]);
  const [selectedSerie, setSelectedSerie] = useState(null);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [serieToDelete, setSerieToDelete] = useState(null);
  const [loadingEnregistreurs, setLoadingEnregistreurs] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });
  const navigate = useNavigate();
  const API_BASE = "https://srv968119.hstgr.cloud";
  const sendWhatsAppLogin = async (user) => {
    try {
      // 1️⃣ Appel backend pour générer / récupérer mot de passe
      const response = await fetch(`${API_BASE}/users/whatsapp-login/${user.id_user}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });

      const data = await response.json();
      if (!data.success) {
        showToast("Erreur génération mot de passe", "error");
        return;
      }

      // 2️⃣ Message WhatsApp
      const message = `
  Compte SNER
  Login : ${user.telephone}
  Mot de passe : ${data.password}, merci de modifier votre mot de passe après la première connexion. APK: https://drive.google.com/file/d/13B94fLkIsc8i5TOCDvXUsE_Z85KCEO92/view?usp=sharing
      `.trim();

      // 3️⃣ Lien WhatsApp
      const phone = `227${user.telephone}`;
      const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

      window.open(url, "_blank");
      showToast("WhatsApp prêt à être envoyé", "success");
    } catch (err) {
      console.error(err);
      showToast("Erreur WhatsApp", "error");
    }
  };

  // Fonction pour afficher un toast
  const showToast = (message, type = "info") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "info" });
    }, 4000);
  };
  const userStatu = localStorage.getItem("statu");

  const handleDelete = async () => {
    if (!selectedUser) return;

    try {
      await deleteUser(selectedUser.id_user);
      fetchuser();
      document.getElementById("delete_modal").close();
      setSelectedUser(null);
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
    }
  };

  const rebootPassword = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE}/users/reboot-password/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword: "12345" }),
      });
      const data = await response.json();
      if (data.success) {
        showToast("Mot de passe réinitialisé à 12345 !", "success");
      } else {
        showToast(data.error || "Erreur lors de la réinitialisation du mot de passe", "error");
      }
    } catch (error) {
      showToast("Erreur lors de la réinitialisation du mot de passe", "error");
      console.error(error);
    }
  };

  const fetchuser = async () => {
    try {
      const params = new URLSearchParams();
      if (selectedService) params.append("service", selectedService);
      if (searchTerm) params.append("search", searchTerm);

      const response = await fetch(`${API_BASE}/users?${params.toString()}`);
      let data = await response.json();

      // Filtrer selon le service du statu
      if (userStatu === "admin_police") {
        data = data.filter(u => u.service === "POLICE");
      } else if (userStatu === "admin_gendarmerie") {
        data = data.filter(u => u.service === "GENDARMERIE");
      }else if (userStatu === "admin_douane") {
        data = data.filter(u => u.service === "DOUANE");
      }

      // Trier les contrôleurs en premier et par nombre de checks décroissant
      data.sort((a, b) => {
        const isAController = a.statu.includes("controleur");
        const isBController = b.statu.includes("controleur");

        if (isAController && !isBController) return -1;
        if (!isAController && isBController) return 1;
        if (isAController && isBController) {
          return b.nombre_checks - a.nombre_checks;
        }
        return 0;
      });

      setuser(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs :", error);
    }
  };

  const fetchSeries = async () => {
    try {
      const response = await fetch(`${API_BASE}/series`);
      const data = await response.json();
      if (data.success) {
        setSeries(data.data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des numéros de série :", error);
    }
  };

  const fetchEnregistreurs = async () => {
    try {
      setLoadingEnregistreurs(true);
      const response = await fetch(`${API_BASE}/users/`);
      let data = await response.json();

      // Filtrer selon le service du statu
      // if (userStatu === "admin_police") {
      //   data = data.filter(u => u.service === "police");
      // } else if (userStatu === "admin_gendarmerie") {
      //   data = data.filter(u => u.service === "gendarmerie");
      // }

      // Filtrer uniquement les enregistreurs
      data = data.filter(u => u.statu === "enregistreur");
      setEnregistreurs(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des enregistreurs :", error);
    } finally {
      setLoadingEnregistreurs(false);
    }
  };

  const generateSerie = async () => {
    try {
      const response = await fetch(`${API_BASE}/series/generate`, {
        method: 'GET'
      });
      const data = await response.json();
      if (data.success) {
        fetchSeries();
        showToast("Code série généré avec succès !", "success");
      } else {
        showToast("Erreur lors de la génération du code série", "error");
      }
    } catch (error) {
      console.error("Erreur lors de la génération du code série :", error);
      showToast("Erreur lors de la génération du code série", "error");
    }
  };

  const assignSerie = async (idSerie, idUser) => {
    try {
      const response = await fetch(`${API_BASE}/series/assign/${idSerie}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id_user: idUser })
      });
      const data = await response.json();
      if (data.success) {
        fetchSeries();
        setAssignModalOpen(false);
        setSelectedSerie(null);
        showToast("Code série affecté avec succès !", "success");
      } else {
        showToast(data.message || "Erreur lors de l'affectation du code série", "error");
      }
    } catch (error) {
      console.error("Erreur lors de l'affectation du code série :", error);
      showToast("Erreur lors de l'affectation du code série", "error");
    }
  };

  const deleteSerie = async (idSerie) => {
    try {
      const response = await fetch(`${API_BASE}/series/${idSerie}`, {
        method: 'DELETE'
      });
      const data = await response.json();
      if (data.success) {
        fetchSeries();
        showToast("Clef d'authentification supprimée avec succès !", "success");
      } else {
        showToast(data.message || "Erreur lors de la suppression de la clef", "error");
      }
    } catch (error) {
      console.error("Erreur lors de la suppression de la clef :", error);
      showToast("Erreur lors de la suppression de la clef", "error");
    }
  };

  const createUser = async (userData) => {
    const token = localStorage.getItem("token");
    await fetch(`${API_BASE}/users`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(userData),
    });
  };

  useEffect(() => {
    fetchuser();
    if (activeTab === "series") {
      fetchSeries();
    }
  }, [selectedService, searchTerm, activeTab]);

  const handleHistoriqueClick = (userId) => {
    navigate(`/historique-controleur/${userId}`);
  };

  const isAdminController = userStatu === "admin_police" || userStatu === "admin_gendarmerie"|| userStatu === "admin_douane";

  return (
    <div className="px-3 sm:px-4 md:px-6 lg:px-8 py-4 bg-gray-100 dark:bg-gray-900 w-full flex flex-col rounded-xl mt-4">
      {/* Onglets */}

      <div className="tabs tabs-boxed mb-4 ">
        {userStatu === "admin"&&(<><button
          className={`tab ${activeTab === "users" ? "tab-active" : ""}`}
          onClick={() => setActiveTab("users")}
        >
          Gestion des Utilisateurs
        </button>

        <button
          className={`tab ${activeTab === "series" ? "tab-active" : ""}`}
          onClick={() => setActiveTab("series")}
        >
          Gestion des clefs d'authentifications
        </button></>)}
      </div>

      {activeTab === "users" ? (
        <>
          <UserForm onAdd={() => fetchuser()} />

          <div className="flex gap-2 mb-3">


         {userStatu === "admin"?(
            <select
              className="select select-bordered"
              value={selectedService}
              onChange={e => setSelectedService(e.target.value)}
            >
              <option value="">Tous les services</option>
              <option value="SNER">SNER</option>
              <option value="POLICE">POLICE</option>
              <option value="GENDARMERIE">GENDARMERIE</option>
              <option value="DOUANE">DOUANE</option>
              <option value="MINISTERE DE TRANSPORT">MINISTERE DE TRANSPORT</option>

            </select>):(<></>)}
            <input
              type="text"
              placeholder="Rechercher un Utilisateur..."
              className="input input-bordered w-full input-sm sm:input-md dark:bg-gray-700 dark:text-white"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="overflow-x-auto overflow-y-auto h-[28rem] bg-base-100 rounded-xl shadow border border-base-200 mt-2">
            <table className="table table-zebra">
              <thead className="sticky top-0 z-10">
                <tr className="bg-base-200 text-xs sm:text-sm">
                  <th className="whitespace-nowrap">Matricule</th>
                  <th className="whitespace-nowrap">Nom</th>
                  <th className="hidden sm:table-cell whitespace-nowrap">Téléphone</th>
                  <th className="hidden md:table-cell whitespace-nowrap">Service</th>
                  <th className="hidden lg:table-cell whitespace-nowrap">Unité</th>
                  <th className="whitespace-nowrap">Statut</th>
                  <th className="hidden lg:table-cell whitespace-nowrap">Détails</th>
                  {isAdminController && (
                    <>
                      <th className="hidden md:table-cell whitespace-nowrap">Dernier check</th>
                      <th className="hidden md:table-cell whitespace-nowrap">Total checks</th>
                    </>
                  )}
                  <th className="whitespace-nowrap">Options</th>
                </tr>
              </thead>
              <tbody>
                {user.map((user) => (
                  <tr key={user.id_user} className="hover text-xs sm:text-sm">
                    <td className="font-medium">{user.matricule}</td>
                    <td>{user.nom?.toUpperCase()}</td>
                    <td className="hidden sm:table-cell">{user.telephone ? user.telephone.toUpperCase() : "N/A"}</td>
                    <td className="hidden md:table-cell">{user.service?.toUpperCase()}</td>
                    <td className="hidden lg:table-cell">{user.unite?.toUpperCase()}</td>
                    <td>{user.statu?.toUpperCase()}</td>
                    <td className="hidden lg:table-cell">{user.Details?.toUpperCase()}</td>
                    {isAdminController && (
                      <>
                        <td className="hidden md:table-cell">
                          {user.dernier_check ? new Date(user.dernier_check).toLocaleString() : "Jamais"}
                        </td>
                        <td className="hidden md:table-cell">{user.nombre_checks}</td>
                      </>
                    )}
                    <td className="relative">
                      <button
                        className="btn btn-xs sm:btn-sm"
                        onClick={() => setDropdownOpen(dropdownOpen === user.id_user ? null : user.id_user)}
                      >
                        Actions ▼
                      </button>

                      {dropdownOpen === user.id_user && (
                        <div className="absolute right-0 mt-1 w-44 bg-white border border-gray-200 rounded shadow-lg z-50">
                          {(user.statu === "controleur_police" || user.statu === "controleur_gendarmerie") && (
                            <button
                              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                              onClick={() => {
                                navigate(`/historique-controleur`, {
                                  state: {
                                    id: user.id_user,
                                    nom: user.nom,
                                    telephone: user.telephone
                                  }
                                });
                                setDropdownOpen(null);
                              }}
                            >
                              Historique
                            </button>
                          )}
                          <button
                            className="block w-full text-left px-4 py-2 text-green-600 hover:bg-gray-100"
                            onClick={async () => {
                              try {
                                await fetch(`${API_BASE}/users/resend-password/${user.id_user}`, {
                                  method: "GET",
                                  headers: { "Content-Type": "application/json" }
                                });
                                showToast("Mot de passe renvoyé par SMS !", "success");
                              } catch (error) {
                                showToast("Erreur lors de l'envoi du mot de passe", "error");
                                console.error(error);
                              }
                              setDropdownOpen(null);
                            }}
                          >
                            Renvoyer par sms
                          </button>
                          <button
  className="block w-full text-left px-4 py-2 text-green-700 hover:bg-gray-100"
  onClick={() => {
    sendWhatsAppLogin(user);
    setDropdownOpen(null);
  }}
>
  Renvoyer par WhatsApp
</button>

                          <button
                            className="block w-full text-left px-4 py-2 text-orange-600 hover:bg-gray-100"
                            onClick={() => {
                              setSelectedUser(user);
                              document.getElementById("reboot_modal").showModal();
                              setDropdownOpen(null);
                            }}
                          >
                            Reboot mot de passe
                          </button>
                          <button
                            className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
                            onClick={() => {
                              setSelectedUser(user);
                              document.getElementById("delete_modal").showModal();
                              setDropdownOpen(null);
                            }}
                          >
                            Supprimer
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <dialog id="delete_modal" className="modal bg-black bg-opacity-20">
              <div className="modal-box">
                <h3 className="font-bold text-lg">Confirmation</h3>
                <p>Voulez-vous vraiment supprimer cet utilisateur ?</p>
                <div className="modal-action flex justify-between">
                  <button className="btn" onClick={() => document.getElementById("delete_modal").close()}>
                    Annuler
                  </button>
                  <button className="btn btn-error" onClick={handleDelete}>
                    Supprimer
                  </button>
                </div>
              </div>
            </dialog>

            <dialog id="reboot_modal" className="modal bg-black bg-opacity-20">
              <div className="modal-box">
                <h3 className="font-bold text-lg">Confirmation</h3>
                <p>Voulez-vous vraiment réinitialiser le mot de passe de cet utilisateur à <b>12345</b> ?</p>
                <div className="modal-action flex justify-between">
                  <button className="btn" onClick={() => document.getElementById("reboot_modal").close()}>
                    Annuler
                  </button>
                  <button
                    className="btn btn-warning"
                    onClick={async () => {
                      await rebootPassword(selectedUser.id_user);
                      document.getElementById("reboot_modal").close();
                      setSelectedUser(null);
                    }}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </dialog>
          </div>
        </>
      ) : (
        <>
          {/* Gestion des numéros de série */}
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold">Gestion des clefs d'authentification</h2>
            <button
              className="btn btn-primary"
              onClick={generateSerie}
            >
              Générer une clef
            </button>
          </div>

          <div className="overflow-x-auto overflow-y-auto h-[28rem] bg-base-100 rounded-xl shadow border border-base-200">
            <table className="table table-zebra">
              <thead className="sticky top-0 z-10">
                <tr className="bg-base-200 text-xs sm:text-sm">
                  <th className="whitespace-nowrap">Identifiant</th>
                  <th className="whitespace-nowrap">Code</th>

                  <th className="whitespace-nowrap">Date de Création</th>
                  <th className="whitespace-nowrap">Actions</th>
                </tr>
              </thead>
              <tbody>
                {series.map((serie) => (
                  <tr key={serie.id_Serie} className="hover text-xs sm:text-sm">
                    <td className="font-medium">{serie.id_Serie}</td>
                    <td className="font-mono">{serie.code_serie}</td>

                    <td>
                      {new Date(serie.createdAt).toLocaleDateString()}
                    </td>
                    <td className="relative">
                      <button
                        className="btn btn-xs sm:btn-sm"
                        onClick={() => setDropdownOpen(dropdownOpen === serie.id_Serie ? null : serie.id_Serie)}
                      >
                        Actions ▼
                      </button>

                          {dropdownOpen === serie.id_Serie && (
                        <div className="absolute right-0 mt-1 w-44 bg-white border border-gray-200 rounded shadow-lg z-50">

                            <button
                              className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
                              onClick={() => {
                                setSerieToDelete(serie);
                                setDropdownOpen(null);
                              }}
                            >
                              Supprimer
                            </button>

                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Modal d'affectation */}
          {assignModalOpen && (
            <dialog className="modal modal-open">
              <div className="modal-box">
                <h3 className="font-bold text-lg">Affecter le code série</h3>
                <p className="py-4">
                  Code série : <span className="font-mono font-bold">{selectedSerie?.code_serie}</span>
                </p>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Sélectionner un enregistreur :</span>
                  </label>
                  <select
                    className="select select-bordered"
                    onChange={(e) => {
                      const userId = parseInt(e.target.value);
                      if (userId && selectedSerie) {
                        assignSerie(selectedSerie.id_Serie, userId);
                      }
                    }}
                  >
                    <option value="">Choisir un enregistreur...</option>
                    {loadingEnregistreurs ? (
                      <option value="" disabled>Chargement des enregistreurs...</option>
                    ) : enregistreurs.length === 0 ? (
                      <option value="" disabled>Aucun enregistreur disponible</option>
                    ) : (
                      enregistreurs.map((enregistreur) => (
                        <option key={enregistreur.id_user} value={enregistreur.id_user}>
                          {enregistreur.nom?.toUpperCase()} - {enregistreur.matricule}
                        </option>
                      ))
                    )}
                  </select>
                </div>
                <div className="modal-action">
                  <button
                    className="btn"
                    onClick={() => {
                      setAssignModalOpen(false);
                      setSelectedSerie(null);
                    }}
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </dialog>
          )}

          {/* Modal de suppression de clef */}
          {serieToDelete && (
            <dialog open className="modal bg-black bg-opacity-20">
              <div className="modal-box">
                <h3 className="font-bold text-lg text-red-600">Suppression définitive</h3>
                <p>
                  Cette action supprimera définitivement la clef d'authentification
                  <span className="font-mono"> {serieToDelete.code_serie} </span>.
                  Elle ne pourra plus être utilisée pour valider une machine.
                </p>
                <div className="modal-action flex justify-between">
                  <button className="btn" onClick={() => setSerieToDelete(null)}>
                    Annuler
                  </button>
                  <button
                    className="btn btn-error"
                    onClick={async () => {
                      await deleteSerie(serieToDelete.id_Serie);
                      setSerieToDelete(null);
                    }}
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            </dialog>
          )}
        </>
      )}

      {/* Toast Notification */}
      {toast.show && (
        <div className={`toast toast-top toast-end z-50`}>
          <div className={`alert ${
            toast.type === "success" ? "alert-success" :
            toast.type === "error" ? "alert-error" :
            "alert-info"
          }`}>
            <div>
              <span className="font-bold">
                {toast.type === "success" ? "✅" :
                 toast.type === "error" ? "❌" :
                 "ℹ️"}
              </span>
              <span>{toast.message}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
